import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        }
    }

    static getDerivedStateFromError(error) {
        return { error: true };
      }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
      }

    render() {
        if (this.state.error) {
            return <h1>{this.props.errorMessage ? this.props.errorMessage : "Something went wrong." }</h1>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;